<template lang="pug">
ActivitiesLocationInfoWindow.activities-location-job-site-info-window(
  :report-url="reportUrl"
  :pan-by-offset="-95"
  @close="onClose"
)
  template(slot="updated-at")
    | {{ lastVisitedFromNow }}
  template(slot="avatar")
    img.hidden-xs(:src="generateCustomColorMarker(marker.color, true)")
  template(slot="primary-detail")
    strong {{ marker.name }}
  template(slot="secondary-detail")
    | {{ marker.address }}
  template(slot="tertiary-detail")
    | {{ `${marker.radius} m radius` }}
  template(slot="cell-one")
    .info-window-label {{ membersOnSiteLabel }}
    .sk.sk--line.sk--line--quarter(v-if="loading")
    .info-window-members-on-site(v-else) {{ membersOnSite }}
  template(slot="cell-two")
    .info-window-label {{ totalVisitsLabel }}
    .sk.sk--line.sk--line--quarter(v-if="loading")
    .info-window-total-visits(v-else) {{ totalVisits || '-' }}
  template(slot="list-label")
    span(v-if="totalVisits > 0") MEMBERS VISITS
  template(slot="list-items")
    template(v-if="loading")
      .col-xs-12.d-flex(
        v-for="n in 3"
        :key="'sk-' + n"
      )
        .sk.sk--circle.sk--circle--xs.mr-5
        .sk.sk--line.sk--line--half.mr-30
        .sk.sk--line.sk--line--half
    template(v-else)
      ActivitiesLocationInfoWindowListItem(
        v-for="visit in visitsToDisplay"
        :key="visit.id"
        :job-site-visit="visit"
        :zone="activeTimeZone.name"
        :emit-id="visit.user_id"
        @click="onListItemClick"
      )
        template(slot="name")
          | {{ getMember(visit.user_id).name }}
        template(slot="avatar")
          HubAvatar(
            :user-id="visit.user_id"
            avatar-style="speck"
          )
    .sk.sk--line.sk--line--quarter(v-if="loading")
    template(v-else)
      .col-xs-12.and-more(v-if="totalVisits > 3")
        | {{ `and ${visitedCountExcess} more` }}
</template>

<script>
import { get } from 'lodash-es';
import { generateMarker } from '~/mixins';
import { mapActions, mapGetters, mapState } from 'vuex';
import { parseInternalDatetime } from '~/utils/time_utils';

export default {
  name: 'ActivitiesLocationJobSiteInfoWindow',
  mixins: [generateMarker],
  props: {
    marker: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    visits: [],
    updatedAt: null,
  }),
  computed: {
    ...mapState(['users']),
    ...mapState({
      loading: (state) => get(state, 'loading.siteDetails', false),
    }),
    ...mapGetters(['reportUrl', 'isPastView', 'memberMarkers', 'activeTimeZone']),
    totalVisitsLabel() {
      return 'TOTAL VISITS' + (!this.isPastView ? ' TODAY' : '');
    },
    membersOnSiteLabel() {
      return 'MEMBERS ON SITE' + (!this.isPastView ? ' NOW' : '');
    },
    lastVisited() {
      return this.updatedAt ? parseInternalDatetime(this.updatedAt) : null;
    },
    lastVisitedFromNow() {
      return this.lastVisited ? this.lastVisited.fromNow() : '-';
    },
    totalVisits() {
      return this.visits.length;
    },
    membersOnSite() {
      return this.visits.filter((visit) => !visit.exit_at).length;
    },
    visitedCountExcess() {
      return this.totalVisits ? this.totalVisits - 3 : 0;
    },
    visitsToDisplay() {
      return this.visits.slice(0, 3);
    },
  },
  async mounted() {
    await this.loadDetails();
  },
  destroyed() {
    this.visits = [];
    this.updatedAt = null;
  },
  methods: {
    ...mapActions(['loadSiteDetails']),
    getMember(id) {
      return get(this.users, id, {});
    },
    onListItemClick(id) {
      const marker = this.memberMarkers.find((mark) => mark.id === id);

      this.$emit('close');
      this.$emit('click', marker);
    },
    onClose() {
      this.$emit('close');
    },
    async loadDetails() {
      const { id } = this.marker;
      const response = await this.loadSiteDetails(id);

      if (!response) {
        this.$appMessage('Error loading site details');

        return;
      }

      this.visits = get(response, 'visits', []);
      this.updatedAt = get(response, 'updatedAt', new Date().toISOString());
    },
  },
};
</script>
